import { AddCircle, Clear, ContentPaste, Delete, Edit, Search } from "@mui/icons-material";
import { Box, Card, CardContent, FormControl, Grid } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogEdit from "./modal/dialogEdit";
import DialogNew from "./modal/dialogNew";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";
import messages from "../../../utils/messages";
import serviceSaldoInstalacao from "../../../services/serviceSaldoInstalacao";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const Saldos = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Faturamento - Saldos");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [exclusionState, setExclusionState] = useState({
        data: "",
        open: false,
    });
    const [editState, setEditState] = useState({
        open: false,
        id: "",
        quantidadeKW: "0,00",
    });
    const history = useHistory();
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            usinaID: 0,
            tipoSaldo: "",
            numeroInstalacao: "",
            mesUltimaAtualizacao: null,
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 170,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Histórico de Saldo">
                                <ContentPaste />
                            </Tooltip>
                        }
                        label="Histórico de Saldo"
                        onClick={() => onClickHistoricoSaldos(params.row.numeroInstalacao)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                quantidadeKW: params.row.quantidadeKW,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "saldoInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 180,
            },
            {
                headerName: "Qtd kilowatt",
                field: "quantidadeKW",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Tipo",
                field: "tipoSaldo",
                type: "string",
                width: 180,
            },
            {
                headerName: "Última atualização",
                field: "dataHoraUltimaAtualizacao",
                type: "date",
                width: 180,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const tipoSaldoOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Reenergisa", value: "Reenergisa" },
        { label: "Outras Empresas", value: "Outras Empresas" },
        { label: "Concessionária", value: "Concessionária" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceSaldoInstalacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleDelete = async () => {
        serviceSaldoInstalacao
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoSaldo: values.tipoSaldo === "Todos" ? "" : values.tipoSaldo,
            mesUltimaAtualizacao: values.mesUltimaAtualizacao ? format(values.mesUltimaAtualizacao, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClickHistoricoSaldos = (numeroInstalacao: any) => {
        history.push({
            pathname: "/faturamento/historicosaldo",
            state: { numeroInstalacao: numeroInstalacao },
        });
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container columnSpacing={2}>
                                <Grid item md={8}>
                                    <Grid container columnSpacing={2} display="flex" alignItems="center">
                                        <Grid item md={7}>
                                            <AutoComplete
                                                name="usinaID"
                                                label="Nome da usina"
                                                options={usinaDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={5}>
                                            <InputNumber
                                                name="numeroInstalacao"
                                                label="Instalação"
                                                control={control}
                                                error={errors}
                                                decimalScale={0}
                                                noThousandSeparator
                                                maxLength={15}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={4}>
                                    <Grid container columnSpacing={2} display="flex" alignItems="center">
                                        <Grid item md={6}>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                color="warning"
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                                disableElevation
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>
                                        <Grid item md={6}>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container columnSpacing={2}>
                                <Grid item md={8}>
                                    <Grid container columnSpacing={2}>
                                        <Grid item md={7}>
                                            <AutoComplete
                                                name="tipoSaldo"
                                                label="Tipo de saldo"
                                                options={tipoSaldoOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                        <Grid item md={5}>
                                            <DatePickerMui
                                                name="mesUltimaAtualizacao"
                                                label="Última atualização"
                                                format="MM/yyyy"
                                                view={["month", "year"]}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={4} display="flex" justifyContent="flex-start">
                                    <Grid container columnSpacing={2} display="flex" alignItems="center">
                                        <Grid item md={6}>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                disableElevation
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                                sx={{ mr: 1 }}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                        <Grid item md={6}></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}></FormControl>
                    </div>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.saldoInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            quantidadeKW: editState.quantidadeKW,
                        }}
                        onClose={() => {
                            setEditState({ open: false, id: "", quantidadeKW: "0,00" });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default Saldos;
